import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';

import {map} from 'rxjs/operators';

import {MapUtils} from '../../shared/utils/mapper';
import {FXResponse} from 'src/app/models/response.model';
import {standardizeParam} from 'src/app/shared/utils/helper';
import {Deposit, Wallet, WalletSetting, ManualHistory} from 'src/app/models/wallet.model';
import {WalletReport} from 'src/app/models/wallet-report.model';
import {APP_CONFIG} from 'src/app/shared/common/config';
import {ExchangeTransaction, Transaction} from 'src/app/models/transaction.model';
import {DUMMY_DATA} from 'src/app/shared/utils/data';

@Injectable()
export class WalletService {
  // URL to web api.
  private walletUrl = APP_CONFIG.BASE_API_LINK.WALLET;

  constructor(private http: HttpClient) {}

  getTransactions<T>(
    params: any,
    type: string,
    model: any
  ): Observable<FXResponse<T[]>> {
    return this.http
      .get(
        `${
          APP_CONFIG.BASE_API_LINK.WALLET
        }/${type}-transactions?${standardizeParam(params)}`,
      )
      .pipe(
        map((res: any) => {
          const data = res.data[`${type.replace('-', '_')}_transactions`];
          const response = new FXResponse<T[]>().deserialize(res);
          response.paging = res.data.paging;
          response.data = data.map((trans: any) =>
            MapUtils.deserialize(model, trans),
          );
          return response;
        }),
      );
    /*return new Observable<FXResponse<T[]>>((observer) => {
      const res: any =
        DUMMY_DATA.WALLET[`${type.replace('-', '_')}`.toUpperCase()];
      observer.next(res);
      observer.complete();
    }).pipe(
      map((res: any) => {
        const data = res.data[`${type.replace('-', '_')}_transactions`];
        const response = new FXResponse<T[]>().deserialize(res);
        response.paging = res.data.paging;
        response.data = data.map((trans: any) =>
          MapUtils.deserialize(model, trans)
        );
        return response;
      })
    );*/
  }

  getRequests<T>(
    params: any,
    type: string,
    model: any
  ): Observable<FXResponse<T[]>> {
    return this.http
      .get(
        `${
          APP_CONFIG.BASE_API_LINK.WALLET
          }/${type}?${standardizeParam(params)}`,
      )
      .pipe(
        map((res: any) => {
          const data = res.data[`${type.replace(/-/gi, '_')}`];
          const response = new FXResponse<T[]>().deserialize(res);
          response.paging = res.data.paging;
          response.data = data.map((trans: any) =>
            MapUtils.deserialize(model, trans),
          );
          return response;
        }),
      );
  }
  updateStatusBankRequest(body: any): Observable<FXResponse<any>> {
    return this.http.post(
      `${APP_CONFIG.BASE_API_LINK.WALLET}/banking-withdraws/process`, body).pipe(
      map((res: any) => {
        const response = new FXResponse<any>().deserialize(res);
        return response;
      })
    );
  }

  getManualDepositWithdraw<T>(
    params: any,
    type: string,
    model: any
  ): Observable<FXResponse<T[]>> {
    if (type === 'manual-deposit-withdraw') {
      type = 'manual-transactions';
    }
    return this.http
      .get(
        `${
          APP_CONFIG.BASE_API_LINK.WALLET
          }/${type}?${standardizeParam(params)}`,
      )
      .pipe(
        map((res: any) => {
          if (type === 'manual-transactions')  {
            type = 'manual-deposit-withdraw';
          }
          const data = res.data[`${type.replace(/-/gi, '_')}`];
          const response = new FXResponse<T[]>().deserialize(res);
          response.paging = res.data.paging;
          response.data = data.map((trans: any) =>
            MapUtils.deserialize(model, trans),
          );
          return response;
        }),
      );
  }

  updateManualAmount(form: any): Observable<any> {
    const url = `${APP_CONFIG.BASE_API_LINK.WALLET}/manual-transactions/process`;
    return this.http.post(url, form).pipe(
      map((res: any) => {
        return res;
      })
    );
  }
  getHistoryMT4Transactions(params: any): Observable<FXResponse<ManualHistory[]>> {
    return this.http
      .get(
        `${
          APP_CONFIG.BASE_API_LINK.WALLET
          }/manual-history?${standardizeParam(params)}`
      )
      .pipe(
        map((res: any) => {
          const response = new FXResponse<ManualHistory[]>().deserialize(res);
          response.data = res.data.map((trans: any) =>
            MapUtils.deserialize(ManualHistory, trans)
          );
          return response;
        })
      );
  }
  getBalanceTransactions(params: any): Observable<FXResponse<Transaction[]>> {
    return this.http
      .get(
        `${
          APP_CONFIG.BASE_API_LINK.WALLET
        }/balance-transactions?${standardizeParam(params)}`
      )
      .pipe(
        map((res: any) => {
          const data = res.data.balance_transactions;
          const response = new FXResponse<Transaction[]>().deserialize(res);
          response.paging = res.data.paging;
          response.data = data.map((trans: any) =>
            MapUtils.deserialize(Transaction, trans)
          );
          return response;
        })
      );
    // return new Observable<FXResponse<Transaction[]>>((observer) => {
    //   const res: any = DUMMY_DATA.WALLET.BALANCE;
    //   observer.next(res);
    //   observer.complete();
    // }).pipe(
    //   map((res: any) => {
    //     const data = res.data.balance_transactions;
    //     const response = new FXResponse<Transaction[]>().deserialize(res);
    //     response.paging = res.data.paging;
    //     response.data = data.map((trans: any) =>
    //       MapUtils.deserialize(Transaction, trans)
    //     );
    //     return response;
    //   })
    // );
  }

  getExchangeTransactions(
    params: any
  ): Observable<FXResponse<ExchangeTransaction[]>> {
    return this.http
      .get(
        `${
          APP_CONFIG.BASE_API_LINK.WALLET
        }/exchange-transactions?${standardizeParam(params)}`
      )
      .pipe(
        map((res: any) => {
          const data = res.data.exchange_transactions;
          const response = new FXResponse<
            ExchangeTransaction[]
          >().deserialize(res);
          response.paging = res.data.paging;
          response.data = data.map((trans: any) =>
            MapUtils.deserialize(ExchangeTransaction, trans)
          );
          return response;
        })
      );
    /*return new Observable<FXResponse<ExchangeTransaction[]>>((observer) => {
      const res: any = DUMMY_DATA.WALLET.EXCHANGE;
      observer.next(res);
      observer.complete();
    }).pipe(
      map((res: any) => {
        const data = res.data.exchange_transactions;
        const response = new FXResponse<ExchangeTransaction[]>().deserialize(
          res
        );
        response.paging = res.data.paging;
        response.data = data.map((trans: any) =>
          MapUtils.deserialize(ExchangeTransaction, trans)
        );
        return response;
      })
    );*/
  }

  getWallets(params: any, type: string): Observable<FXResponse<Wallet[]>> {
    let url = `${
      APP_CONFIG.BASE_API_LINK.WALLET
    }/bitgo-transactions?${standardizeParam(params)}`;
    if (type === 'perfect-money') {
      url = `${
        APP_CONFIG.BASE_API_LINK.WALLET
      }/perfect-money-transactions?${standardizeParam(params)}`;
    } else if (type === 'sticpay') {
      url = `${
        APP_CONFIG.BASE_API_LINK.WALLET
      }/sticpay-transactions?${standardizeParam(params)}`;
    }
    return this.http.get(url).pipe(
      map((res: any) => {
        const data = res.data;
        const response = new FXResponse<Wallet[]>().deserialize(res);
        response.data = data.map((trans: any) =>
          MapUtils.deserialize(Wallet, trans)
        );
        return response;
      })
    );
  }

  approveWallet(type: string, data: any): Observable<any> {
    let url = `${APP_CONFIG.BASE_API_LINK.WALLET}`;
    switch (type) {
      case 'bitgo': {
        url += `/bitgo-transactions/process`;
        break;
      }
      case 'sticpay': {
        url += `/sticpay-transactions/process`;
        break;
      }
      case 'perfect-money': {
        url += `/perfect-money-transactions/process`;
        break;
      }
      default:
        url += `/banking-transactions/process`;
        break;
    }
    return this.http.post(url, data).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  getReports(): Observable<FXResponse<WalletReport>> {
    return this.http.get(`${APP_CONFIG.BASE_API_LINK.WALLET}/summary`).pipe(
      map((res: any) => {
        const data = res.data;
        const response = new FXResponse<any>().deserialize(res);
        response.data = MapUtils.deserialize(WalletReport, data);
        return response;
      })
    );
  }

  getUsers(params: any): Observable<any> {
    return this.http.get(
      `${APP_CONFIG.BASE_API_LINK.WALLET}/users/searching?${standardizeParam(
        params
      )}`
    );
  }

  getDeposits(params: any): Observable<FXResponse<Deposit[]>> {
    // return this.http
    //   .get(
    //     `${
    //       APP_CONFIG.BASE_API_LINK.WALLET
    //     }/banking-transactions?${standardizeParam(params)}`
    //   )
    //   .pipe(
    //     map((res: any) => {
    //       const data = res.data.banking_transactions;
    //       const response = new FXResponse<Deposit[]>().deserialize(res);
    //       response.paging = res.data.paging;
    //       response.data = data.map((dps: any) =>
    //         MapUtils.deserialize(Deposit, dps)
    //       );
    //       return response;
    //     })
    //   );
    return new Observable<FXResponse<Deposit[]>>((observer) => {
      const res: any = DUMMY_DATA.WALLET.BANKING;
      observer.next(res);
      observer.complete();
    }).pipe(
      map((res: any) => {
        const data = res.data.banking_transactions;
        const response = new FXResponse<Deposit[]>().deserialize(res);
        response.paging = res.data.paging;
        response.data = data.map((dps: any) =>
          MapUtils.deserialize(Deposit, dps)
        );
        return response;
      })
    );
  }

  transferDeposit(data: any): any {
    return this.http
      .post(`${APP_CONFIG.BASE_API_LINK.WALLET}/make-banking-deposit`, data)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  getWalletSetting(): Observable<FXResponse<WalletSetting>> {
    return this.http.get(`${APP_CONFIG.BASE_API_LINK.WALLET}/setting`).pipe(
      map((res: any) => {
        const data = res.data;
        const response = new FXResponse<WalletSetting>().deserialize(res);
        response.data = MapUtils.deserialize(WalletSetting, data);
        return response;
      })
    );
  }

  updateWalletSetting(walletSetting: WalletSetting): Observable<any> {
    const jsonData = MapUtils.serialize(walletSetting);
    return this.http
      .put(`${APP_CONFIG.BASE_API_LINK.WALLET}/setting`, jsonData)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  getBankDocument(userId): Observable<FXResponse<any>> {
    return this.http.get(`${APP_CONFIG.BASE_API_LINK.WALLET}/bank-account-info?user_id=${userId}`).pipe(
      map((res: any) => {
        return new FXResponse<any>().deserialize(res);
      })
    );
  }
}
